import createCssGenerator from './create-css-generator';
import generateCssFromHtml from './generate-css-from-html';

export default {
  createCssGenerator,
  generateCssFromHtml,
};
